import React from 'react';
import { useIntl } from 'react-intl';

import { useIsBreakpointSize } from 'app/shared/utils';
import { NavigationButton } from 'app/shared/components/molecules';

interface Props {
  cachedSlug: string;
}

export const RecommendedEventsNavigationButton: React.FC<
  React.PropsWithChildren<Props>
> = ({ cachedSlug }) => {
  const { formatMessage } = useIntl();
  const { isMobile } = useIsBreakpointSize();

  return (
    <NavigationButton
      variant="primary"
      w={isMobile ? undefined : 'fit-content'}
      flexDirection="row"
      disabled={!cachedSlug}
      href={`/cities/${cachedSlug}`}
      fullWidth
    >
      {formatMessage({ id: 'event.recommendedEvents.buttonCTA' })}
    </NavigationButton>
  );
};
